import { Modal, Row, Button } from 'antd'
import React from 'react'
import DynamicForm from '../../../../components/FormElements/DynamicForm/index'
import { Colors } from '../../../../config'
import { FaEye } from 'react-icons/fa'
import * as Yup from 'yup'
import { useMutation } from 'react-query'
import axiosInstance from '../../../../config/api'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setError, setMessage } from '../../../../store/common/generalSlice'
import useAuthApi from '../../../../config/hooks/api/auth/useAuthApi'
import { logoutByExpert, resetState, updateAccessToken, updateLoggedInUser, updateLoginStatus } from '../../../../store/common/authSlice'


const form = {
    name: 'Change Password',
    formFields: [
        {
            name: 'password',
            label: { value: '', classes: '' },
            type: 'password',
            placeholder: 'Password',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
            icon: <FaEye />
        }
    ],
    formValidation: {
        password: Yup.string()
            .required('Password is required')
    }
}

const DeleteAccount = ({ deleteAccountModal, setDeleteAccountModal }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logout } = useAuthApi()

    const expertPasswordConfirmationMutation = useMutation(async (data) => {
        let res = await axiosInstance.delete('/user/delete-account', { data });
        if (res?.status == 200 || res?.data?.status == 200) {
            dispatch(setMessage(res?.data?.data?.message))
            let logoutHandler = await logout()
            if (logoutHandler) {
                dispatch(logoutByExpert(false))
                dispatch(updateAccessToken(''))
                dispatch(updateLoggedInUser(null))
                dispatch(updateLoginStatus(false))
            }
        }
    },
        {
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const handleSubmit = (data) => {
        expertPasswordConfirmationMutation.mutate(data)
    }

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    return (
        <Modal
            open={deleteAccountModal}
            width={300}
            footer={false}
            onCancel={() => setDeleteAccountModal(false)}
            centered
            destroyOnClose
        >
            <Row className='p-5 flex items-center justify-center gap-2'>
                <h2 className='text-lg font-semibold'>Delete Account?</h2>
                <span className='text-[#71828A] text-center'>By deleting your account you will lose all your data within the application. To confirm account deletion please input your password below</span>
                <Row className='w-full mt-4'>
                    <DynamicForm
                        form={form}
                        onSubmit={handleSubmit}
                    />
                    <Button
                        onClick={submitForm}
                        loading={expertPasswordConfirmationMutation?.isLoading}
                        htmlType='submit'
                        className='w-full h-10 mt-3 rounded-md outline-none border-none submit-btn'
                    >
                        Submit
                    </Button>
                </Row>
            </Row>
        </Modal>
    )
}

export default DeleteAccount